import { Navigate } from "react-router-dom";
import App from "../layouts/App";
import Integration from "../layouts/Integration";
import AppIframe from "../layouts/AppIframe";

// The GHL marketplace iframe loads this app at /:accountId/page. accountId
// is the ONLY identifier in the URL — everything else (company_id, plan,
// features) lives on the Account row, looked up by id on mount.
const routes = [
  // Integration (GHL OAuth callback) runs BEFORE any account exists, so it must
  // be reachable without the account gate. The "blank" layout skips
  // MarketplaceProvider/AccountGate and renders the route directly. Declared
  // before "/:accountId/*" so it isn't swallowed by the account splat.
  {
    key: "integration",
    path: "/integration/*",
    element: <Integration />,
    layout: "blank",
  },
   {
    key: "app-iframe",
    path: "/app",
    element: <AppIframe />,
    layout: "blank",
  },
  {
    key: "app",
    path: "/:accountId/*",
    element: <App />,
    layout: "header",
  },
  // Anything without an account id is unmounted — there's nothing to render.
  {
    key: "no-account",
    path: "*",
    element: <Navigate to="/_no_account" replace />,
    layout: "blank",
  },
];

export { routes };
